<template>
	<div class="flex">
		<div v-if="isStacked" class="space-y-2" :class="[width]">
			<div class="flex justify-center">
				<slot name="primary"></slot>
			</div>
			<div class="flex justify-center">
				<slot name="secondary"></slot>
			</div>
		</div>
		<div
			v-else
			class="w-full space-y-2 md:flex md:flex-wrap md:gap-2 md:space-y-0"
		>
			<div class="min-w-content">
				<slot name="primary"></slot>
			</div>
			<div class="min-w-content">
				<slot name="secondary"></slot>
			</div>
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	size: {
		type: Number,
		default: 4,
		required: false,
		validator: (value) => [3, 4, 5, 6].includes(value),
	},
	width: {
		type: String,
		default: 'w-full ',
		required: false,
	},
	isStacked: {
		type: Boolean,
		default: true,
		required: false,
	},
})
</script>
